import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useLocation } from "react-router-dom";
import animationData from "../lottie/json/party-celebration.json";
import animationData1 from "../lottie/json/party-celebration1.json";
import animationData2 from "../lottie/json/party-celebration2.json";
import Copy from "../assets/copy.svg";
import Occasions from "../assets/occassion.svg";
import decor from "../assets/decor.svg";
import profile from "../assets/profile.jpg";
import { useParams, useSearchParams } from "react-router-dom";
import { getYaadeinDetails } from "../helper";
import Loading from "../lottie/Loading";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import Submit from "./Submit";

const s3BaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Invite() {
  const query = useQuery();
  const isSubmitted = query.get("submitPage"); // ?name=John
  const [submitPage, setSubmitPage] = useState(false);
  const [userEmailPopup, setUserEmailPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [yaadeinId, setYaadeinId] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [alertModal, setAlertModal] = useState(false);
  const [message, setMessage] = useState("");
  const [mediaCount, setMediaCount] = useState({
    total: 0,
    videoCount: 0,
    imageCount: 0
  });
  const [yaadeinDetails, setYaadeinDetails] = useState({});
  const [data] = useSearchParams();

  const id = useParams().id;

  useEffect(() => {
    setYaadeinId(id || "");
    setUserEmail(data.get("email") ? data.get("email") : "");
    setUserName(data.get("name") ? data.get("name") : "");
    if (id) {
      if (Object.keys(yaadeinDetails).length < 1 || !yaadeinDetails) {
        getDetails();
      }
    }
  }, [id]);

  useEffect(() => {
    if (!isCheckCondition(yaadeinDetails?.finalize, yaadeinDetails?.dateOfOccasion)) {
      if (isSubmitted === "true") {
        setSubmitPage(true)
      }
    }
  }, [isSubmitted, yaadeinDetails])

  useEffect(() => {
    if (yaadeinDetails?.yaadeinMedia?.media?.length > 0) {
      let imageCount = 0;
      let videoCount = 0;
      let total = 0;
      const updatedDataForCount = yaadeinDetails?.yaadeinMedia.media.map((listing => {
        if (listing.deleted === false && listing.type !== "music") {
          if (listing.type === "video") {
            videoCount += 1
          } else {
            imageCount += 1
          }
          total += 1
        }
      }))
      setMediaCount({
        total: total,
        videoCount: videoCount,
        imageCount: imageCount
      })
    }
  }, [yaadeinDetails]);

  const getDetails = async () => {
    const email = data.get("email") ? data.get("email") : "";
    setPageLoading(true);
    const yaadeindata = await getYaadeinDetails(id, email);
    setYaadeinDetails(yaadeindata);
    setTimeout(() => {
      setPageLoading(false);
    }, 1000);
  };

  const lottie1 = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const lottie2 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const lottie3 = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function isDatePassed(dateToCheck) {
    // Create a new Date instance for the current date (in local time)
    const currentDate = new Date();
    // Set the current date time to midnight (00:00:00) to compare only the date part
    currentDate.setHours(0, 0, 0, 0);

    // Create a new Date instance for the date to check and set time to midnight
    const checkDate = new Date(dateToCheck);
    checkDate.setHours(0, 0, 0, 0);

    // Compare the dates
    return checkDate < currentDate;
  }

  function getDateAfter7Days(date) {
    const resultDate = new Date(date); // Create a new Date object from the given date
    resultDate.setHours(0, 0, 0, 0);
    resultDate.setDate(resultDate.getDate() + 7); // Add 7 days
    return resultDate;
  }

  function getSmallerDate(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    if (d1 < d2) {
      console.log("The smaller date is:", d1.toDateString());
      return d1;
    } else if (d1 > d2) {
      console.log("The smaller date is:", d2.toDateString());
      return d2;
    } else {
      console.log("Both dates are equal:", d1.toDateString());
      return d1;
    }
  }

  function isCheckCondition(finalize, dateOfOccasion) {
    if (finalize === false) {
      console.log('dateOfOccasion', dateOfOccasion)
      const splitDate = dateOfOccasion && dateOfOccasion.toString().includes('T') ? dateOfOccasion.split('T') : dateOfOccasion
      const sevenDayAfterdateOfOccasion = getDateAfter7Days(splitDate[0])
      console.log('sevenDayAfterdateOfOccasion', sevenDayAfterdateOfOccasion)
      console.log('isDatePassed(smallestDate)', isDatePassed(sevenDayAfterdateOfOccasion))
      return isDatePassed(sevenDayAfterdateOfOccasion)
    } else {
      // console.log('finalizeVideoTime', finalizeVideoTime)
      // console.log('dateOfOccasion', dateOfOccasion)
      // const splitDate = dateOfOccasion && dateOfOccasion.toString().includes('T') ? dateOfOccasion.split('T') : dateOfOccasion
  
      // const sevenDayAfterFinalizeVideo = getDateAfter7Days(finalizeVideoTime)
      // const sevenDayAfterdateOfOccasion = getDateAfter7Days(splitDate[0])
  
      // console.log('sevenDayAfterFinalizeVideo', sevenDayAfterFinalizeVideo)
      // console.log('sevenDayAfterdateOfOccasion', sevenDayAfterdateOfOccasion)
  
      // const smallestDate = getSmallerDate(sevenDayAfterFinalizeVideo, sevenDayAfterdateOfOccasion)
  
      // console.log('smallestDate', smallestDate)
  
      // console.log('isDatePassed(smallestDate)', isDatePassed(smallestDate))
      return true
    }
  }
  console.log('yaadeinDetails', yaadeinDetails)
  return (
    <>
      {pageLoading ? (
        <Loading />
      ) : (
        <>
          {yaadeinDetails && Object.keys(yaadeinDetails).length > 0 ? (
            <>
              {submitPage ? (
                <Submit
                  loading={loading}
                  setLoading={setLoading}
                  yaadeinDetails={yaadeinDetails}
                  setSubmitPage={setSubmitPage}
                  userName={userName}
                  userEmail={userEmail}
                  yaadeinId={yaadeinId}
                />
              ) : (
                <section className="preview_video">
                  <img src={`${s3BaseUrl}${yaadeinDetails.yaadeinInvite.themePhoto}`} />
                  <div className="lottie1">
                    <Lottie options={lottie3} height={160} width="100%" />
                  </div>
                  <div className="lottie2">
                    <Lottie options={lottie3} height={160} width="100%" />
                  </div>
                  <div className="lottie3">
                    <Lottie options={lottie1} height="100%" width="100%" />
                  </div>
                  <div className="lottie4">
                    <Lottie options={lottie2} height="100%" width={300} />
                  </div>
                  <div className="preview_box">
                    <div className="heading" style={{backgroundImage: `url(${s3BaseUrl}${yaadeinDetails.yaadeinInvite.themePhoto})`}}>
                      {
                        yaadeinDetails?.yaadeinInvite?.occasionPhoto &&
                        <div className="image">
                          <img src={`${s3BaseUrl}${yaadeinDetails.yaadeinInvite.occasionPhoto}`} className="h-100" />
                        </div>
                      }
                      <div className="title">
                        Submit your {yaadeinDetails?.celebrationForName} wishing
                        video for
                      </div>
                      <div className="name">{yaadeinDetails?.fullName}</div>
                      {yaadeinDetails &&
                        yaadeinDetails.yaadeinInvite &&
                        yaadeinDetails.yaadeinInvite.hostVideo && (
                          <div className="video">
                            <video
                              controls
                              disablePictureInPicture
                              controlsList="nodownload noplaybackrate"
                              style={{
                                borderRadius: "15px",
                                border:
                                  "1px solid rgba(164, 164, 192, 0.3019607843)",
                                height: "80%",
                                width: "100%",
                                marginBottom: "0px",
                              }}
                            >
                              <source
                                src={`${s3BaseUrl}${yaadeinDetails.yaadeinInvite.hostVideo}`}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                    </div>
                    <div className="box_content">
                      <textarea
                        className="paragraph form-control"
                        rows={13}
                        // onChange={(e) =>
                        //   console.log("e.target.value", e.target.value)
                        // }
                        value={yaadeinDetails?.yaadeinInvite?.instruction || ""}
                      />
                      <div className="email_invite_submission_btn mt-3 mb-3 d-flex justify-content-center">
                        {/* <button className="btn btn-secondary me-3">RSVP</button> */}
                        {yaadeinDetails?.isUserDeleted ? (
                          <p style={{ color: "red" }}>
                            Uh-oh! The Yaadein video has been whisked away by its creator
                          </p>
                          // ) : yaadeinDetails?.finalize ? (
                        ) : !isCheckCondition(yaadeinDetails?.finalize, yaadeinDetails?.dateOfOccasion) ? (
                          // <p style={{ color: "red" }}>
                          //   All set! The Yaadein video is now complete and closed for edits
                          // </p>
                                <button
                                  className="btn btn-primary"
                                  onClick={(e) => {
                                    // if ((mediaCount?.total < 15 && mediaCount?.videoCount < 5)) {
                                      if (userEmail === "") {
                                        setUserEmailPopup(true);
                                      } else {
                                        setSubmitPage(true);
                                      }
                                    // } else {
                                    //   setMessage("Fifteen photos or five videos have already been submitted.");
                                    //   setAlertModal(true);
                                    // }
                                  }}
                                >
                                  Submit Now
                                </button>
                        // ) : yaadeinDetails?.yaadeinInvite?.submissionDeadline &&

                        //   (!isDatePassed(yaadeinDetails?.yaadeinInvite?.submissionDeadline)) ? (
                        //   // (momentTZ.tz(new Date(), momentTZ.tz.guess()).isBefore(momentTZ.tz(yaadeinDetails?.yaadeinInvite?.submissionDeadline, 'UTC').endOf('day'))) ? (
                        //   // (moment.utc(new Date(yaadeinDetails?.yaadeinInvite?.submissionDeadline)) >= moment.utc(new Date())) ? (
                        //   <button
                        //     className="btn btn-primary"
                        //     onClick={(e) => {
                        //         if (userEmail === "") {
                        //           setUserEmailPopup(true);
                        //         } else {
                        //           setSubmitPage(true);
                        //         }
                        //     }}
                        //   >
                        //     Submit Now
                        //   </button>
                        ) : (
                          <p style={{ color: "red" }}>
                            Time’s up! Your contribution didn’t make it in time for Yaadein
                          </p>
                        )}
                      </div>
                      {/* <div className="share_link">
                        <div className="content">
                          <div className="title">Share Your Invite Link</div>
                          <a className="link">
                            {process.env.REACT_APP_SUBMIT_YAADEIN_BASE_URL}yaadein/
                            {yaadeinId}
                          </a>
                        </div>
                        <div className="icon">
                          <CopyToClipboard
                            text={`${process.env.REACT_APP_SUBMIT_YAADEIN_BASE_URL}yaadein/${yaadeinId}`}
                            onCopy={() => alert("Copied")}
                          >
                            <img
                              src={Copy}
                              alt=""
                              style={{ cursor: "pointer" }}
                            />
                          </CopyToClipboard>
                        </div>
                      </div> */}
                      {
                        yaadeinDetails.yaadeinInvite.submissionDeadline && (
                          <div className="input_box deadline email_invite_deadline">
                            <div className="input_lable ">
                              <div>
                                <img src={Occasions} alt="" />
                                Submission Deadline
                              </div>
                              <div className="deadline_date">
                                {yaadeinDetails.yaadeinInvite.submissionDeadline ? moment.utc(
                                  new Date(
                                    yaadeinDetails.yaadeinInvite.submissionDeadline
                                  )
                                ).format("MMMM Do YYYY") : 'NA'}
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </section>
              )}
            </>
          ) : (
            <h2>Something went wrong</h2>
          )}
        </>
      )}
      <Modal
        isOpen={userEmailPopup}
        toggle={() => setUserEmailPopup(!userEmailPopup)}
      >
        <ModalHeader toggle={() => setUserEmailPopup(!userEmailPopup)}>
          Add Your Details
        </ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (userEmail === "" || userName === "") {
                alert("please add email id.");
              } else {
                setUserEmailPopup(!userEmailPopup);
                setSubmitPage(true);
              }
            }}
          >
            <div className="row">
              <div className="col-12 mb-4">
                <div className="d-flex flex-column add_email_modal">
                  <label className="mb-1" htmlFor="name">
                    Name:
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    required
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-12 mb-5">
                <div className="d-flex flex-column add_email_modal">
                  <label className="mb-1" htmlFor="name">
                    Email:
                  </label>
                  <input
                    type="email"
                    placeholder="Email"
                    required
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                  />
                </div>
              </div>
              <br />
              <br />
              <div className="col-12 d-flex justify-content-center">
                <button type="submit" className="btn_primary mx-2">
                  Submit
                </button>
                <Button
                  className="btn_secondary mx-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setUserEmailPopup(!userEmailPopup);
                    setSubmitPage(true);
                    setUserEmail("");
                    setUserName("");
                  }}
                >
                  Skip
                </Button>{" "}
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>
      <Modal
        className="popup"
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
      >
        <ModalHeader toggle={() => setAlertModal(!alertModal)}>
          Alert
        </ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (userEmail === "" || userName === "") {
                alert("please add email id.");
              } else {
                setUserEmailPopup(!userEmailPopup);
                setSubmitPage(true);
              }
            }}
          >
            <div className="row">
              <p>{message}</p>
              <br />
              <br />
              <div className="col-12 d-flex justify-content-center">
                <Button
                  className="btn_secondary mx-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setAlertModal(!alertModal);
                  }}
                >
                  Close
                </Button>{" "}
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}
